export default __webpack_public_path__ + "static/media/apostar_icons_eingabe_1_apodaten.63e192e1.svg";